import React, { Component } from 'react'
import WOW from 'wowjs'

import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'

const wow = new WOW.WOW({ live: false })
wow.init()

class SiteContainer extends Component {
  state = {
    burgerOpen: false,
  }

  handleBurgerCLick() {
    const { burgerOpen } = this.state
    this.setState({
      burgerOpen: !burgerOpen,
    })
    document
      .querySelector('.fmbm-burger')
      .classList.toggle('fmbm-burger--is-active')
    document.body.classList.toggle('body--burger-open')
  }

  render() {
    const { children } = this.props

    return (
      <div className="fmbm-site">
        <Header
          burgerOpen={this.state.burgerOpen}
          handleBurgerCLick={() => this.handleBurgerCLick()}
        />
        {children}
        <Footer handleBurgerCLick={() => this.handleBurgerCLick()} />
      </div>
    )
  }
}

export default SiteContainer



// WEBPACK FOOTER //
// ./src/Containers/SiteContainer/SiteContainer.js